// The "jobs in sports" landing pages (JobsInSportsBanner.js, Page.js), keyed on the page's node id.
// Plain constants, no imports: scripts/exportJobsInSportsPages.js writes them to
// public/jobs-in-sports-pages.json before every build, and the server reads that copy
// (the backend's components/PageBlocks.php) to put the banner and lists in the page's HTML.
//   image / mobileImage: files in /sites/jobs_in_sports_images on the Drupal site
//   sku: what the lead is filed under
//   button: the link shown under the page's course list
//   degrees: the page also shows the conferences placed on it and the Degrees tile
//   jobs: the list of jobs at the bottom of the page (see JobsInSportsList)
export const JOBS_IN_SPORTS_PAGES = {
    117136: {
        image: 'baseball_career_banner_img.png',
        mobileImage: 'baseball_career_banner_mob.png',
        sku: 'Baseball',
        degrees: true,
        jobs: {
            heading: 'Baseball Jobs Can Be Found Almost Everywhere:',
            items: [
                'MLB Player Personnel', 'Sports Radio', 'MLB General Manager', 'Sports Talk Show Host', 'MLB Agent',
                'Sports Commentator', 'MLB Scout', 'Play by Play Announcer', 'MLB Management', 'Press Box',
                'MLB Front Office', 'Sportscaster', 'MLB Game Operations', 'Sports Producer', 'MLB Sports Marketing',
                'Sideline Sports Reporter', 'MLB Media & Community Relations', 'Sports Anchor', 'MLB Account Manager',
                'Sports Broadcasting Internships', 'MLB Baseball Internships', 'Color Commentator', 'MLB Video Department',
                'Sports Media', 'MLB Video Coordinator or Asst. VC', 'Public Relations', 'MiLB Player Personnel',
                'Sports & Entertainment Communication', 'MiLB General Manager', 'Sports Marketing', 'MiLB Agent',
                'Marketing Professional Athletes', 'MiLB Scout', 'New Media Communications', 'MiLB Management',
                'Social Networking for a professional team', 'MiLB Front Office', 'Team Sports Blogger', 'MiLB Game Operations',
                'Sports Information Director (SID) for a university', 'MiLB Sports Marketing',
                'Journalism jobs in radio, TV, internet & print', 'MiLB Media & Community Relations', 'Fan Communications',
                'MiLB Account Manager', 'Marketing Communications', 'MiLB Baseball Internships', 'Brand Building',
                'MiLB Video Department', 'Dugout Reporter', 'MiLB Video Coordinator or Asst. VC',
                'Premium Club & Luxury Suite Sales', 'Coaching', 'Loyalty Programs', 'Scouting',
                'Account Executive & Inside Sales', 'Player Development', 'Brand Activation', 'Player Personnel',
                'Customer Relationship Management', 'Director of Scouting', 'Sponsorship Sales', 'Assistant General Manager',
                'Community Relations', 'General Manager', 'Event Planning', 'Sports Announcing', 'Digital Video Editing',
                'Baseball Analyst',
            ],
        },
    },
    121534: {
        image: 'basketball_career_banner_img_new.png',
        mobileImage: 'basketball_career_banner_mob_new.png',
        sku: 'Basketball',
        degrees: true,
        jobs: {
            heading: 'Basketball Jobs Can Be Found Almost Everywhere:',
            items: [
                'NBA Player Personnel', 'Sports Radio', 'NBA General Manager', 'Sports Talk Show Host', 'NBA Agent',
                'Sports Commentator', 'NBA Scout', '"Play by Play" Announcer', 'NBA Management', 'Press Box',
                'NBA Front Office', 'Sportscaster', 'NBA Game Operations', 'Sports Producer', 'NBA Sports Marketing',
                'Sports Reporter', 'NBA Media & Community Relations', 'Sports Anchor', 'NBA Account Manager',
                'Sports Broadcasting Internships', 'NBA Basketball Internships', 'Color Commentator', 'NBA Video Department',
                'Sports Media', 'NBA Video Coordinator or Asst. VC', 'Public Relations', 'NCAA Player Personnel',
                'Sports & Entertainment Communication', 'NCAA General Manager', 'Sports Marketing', 'NCAA Agent',
                'Marketing Professional Athletes', 'NCAA Scout', 'New Media Communications', 'NCAA Management',
                'Social Networking for a professional team', 'NCAA Front Office', 'Team Sports Blogger', 'NCAA Game Operations',
                'Sports Information Director (SID) for a university', 'NCAA Sports Marketing',
                'Journalism jobs in radio, TV, internet & print', 'NCAA Media & Community Relations', 'Fan Communications',
                'NCAA Account Manager', 'Marketing Communications', 'NCAA Baseball Internships', 'Brand Building',
                'NCAA Video Department', 'Dugout Reporter', 'NCAA Video Coordinator or Asst. VC',
                'Premium Club & Luxury Suite Sales', 'Basketball Coaching', 'Loyalty Programs', 'Basketball Scouting',
                'Account Executive & Inside Sales', 'Basketball Player Development', 'Brand Activation', 'Player Personnel',
                'Customer Relationship Management', 'Director of Basketball Scouting', 'Sponsorship Sales',
                'Assistant General Manager', 'Community Relations', 'General Manager', 'Event Planning', 'Sports Announcing',
                'Digital Video Editing', 'Basketball Analyst',
            ],
        },
    },
    3731: { image: 'football_career_banner_img.png', mobileImage: 'football_career_banner_mob.png', sku: 'Football', degrees: true },
    121533: {
        image: 'hockey_sports_career_desk.png',
        mobileImage: 'hockey_sports_career_mobile.png',
        sku: 'Hockey',
        degrees: true,
        jobs: {
            heading: 'Hockey Jobs Can Be Found Almost Everywhere:',
            items: [
                'NHL Player Personnel', 'Sports Radio', 'NHL General Manager', 'Sports Talk Show Host', 'NHL Agent',
                'Sports Commentator', 'NHL Scout', 'Play by Play Announcer', 'NHL Management', 'Press Box',
                'NHL Front Office', 'Sportscaster', 'NHL Game Operations', 'Sports Producer', 'NHL Sports Marketing',
                'Sports Reporter', 'NHL Media & Community Relations', 'Sports Anchor', 'NHL Account Manager',
                'Sports Broadcasting Internships', 'NHL Hockey Internships', 'Color Commentator', 'NHL Video Department',
                'Sports Media', 'NHL Video Coordinator or Asst. VC', 'Public Relations', 'NCAA Player Personnel',
                'Sports & Entertainment Communication', 'NCAA General Manager', 'Sports Marketing', 'NCAA Agent',
                'Marketing Professional Athletes', 'NCAA Scout', 'New Media Communications', 'NCAA Management',
                'Social Networking for a professional team', 'NCAA Front Office', 'Team Sports Blogger', 'NCAA Game Operations',
                'Sports Information Director (SID) for a university', 'NCAA Sports Marketing',
                'Journalism jobs in radio, TV, internet & print', 'NCAA Media & Community Relations', 'Fan Communications',
                'NCAA Account Manager', 'Marketing Communications', 'NCAA Hockey Internships', 'Brand Building',
                'NCAA Video Department', 'Dugout Reporter', 'NCAA Video Coordinator or Asst. VC',
                'Premium Club & Luxury Suite Sales', 'Hockey Coaching', 'Loyalty Programs', 'Hockey Scouting',
                'Account Executive & Inside Sales', 'Hockey Player Development', 'Brand Activation', 'Player Personnel',
                'Customer Relationship Management', 'Director of Hockey Scouting', 'Sponsorship Sales',
                'Assistant General Manager', 'Community Relations', 'General Manager', 'Event Planning', 'Sports Announcing',
                'Digital Video Editing', 'Hockey Analyst',
            ],
        },
    },
    184924: {
        image: 'sports_agent_banner_img.png',
        mobileImage: 'sports_agent_banner_tab.png',
        sku: 'Sports Agent',
        button: { label: 'Sports Agent Salaries', link: '/program/salaries' },
    },
    121535: {
        image: 'Soccer_Landing_Page_Banner.png',
        mobileImage: 'jobs_in_sports_soccer.png',
        sku: 'Soccer',
        degrees: true,
        jobs: {
            heading: 'Soccer Jobs Can Be Found Almost Everywhere:',
            image: '/images/soccer_map.png',
            items: [
                'EPL Player Personnel', 'Soccer Player Development', 'EPL General Manager', 'Player Personnel', 'EPL Agent',
                'Director of Soccer Scouting', 'EPL Scout', 'Assistant General Manager', 'EPL Management', 'General Manager',
                'EPL Front Office', 'Sports Announcing', 'EPL Game Operations', 'Soccer Analyst', 'EPL Sports Marketing',
                'Sports Radio', 'EPL Media & Community Relations', 'Sports Talk Show Host', 'EPL Account Manager',
                'Sports Commentator', 'EPL Basketball Internships', 'On-field Announcer', 'EPL Video Department', 'Press Box',
                'EPL Video Coordinator or Asst. VC', 'Sportscaster', 'MLS Player Personnel', 'Sports Producer',
                'MLS General Manager', 'Sports Reporter', 'MLS Agent', 'Sports Anchor', 'MLS Scout',
                'Sports Broadcasting Internships', 'MLS Management', 'Color Commentator', 'MLS Front Office', 'Sports Media',
                'MLS Game Operations', 'Public Relations', 'MLS Sports Marketing', 'Sports & Entertainment Communications',
                'MLS Media & Community Relations', 'Sports Marketing', 'MLS Account Manager', 'Marketing Professional Athletes',
                'MLS Basketball Internships', 'New Media Communications', 'MLS Video Department',
                'Social Networking for a professional team', 'MLS Video Coordinator or Asst. VC', 'Team Sports Blogger',
                'MLS Player Personnel', 'Sports Information Director (SID) for a university', 'MLS General Manager',
                'Journalism jobs in radio, TV, internet & print', 'La Liga Agent', 'Fan Communications', 'La Liga Scout',
                'Marketing Communications', 'La Liga Management', 'Brand Building', 'La Liga Front Office',
                'Premium Club & Luxury Suite Sales', 'La Liga Game Operations', 'Loyalty Programs', 'La Liga Sports Marketing',
                'Account Executive & Inside Sales', 'La Liga Account Manager', 'Brand Activation',
                'La Liga Media & Community Relations', 'Customer Relationship Management', 'La Liga Video Department',
                'Sponsorship Sales', 'La Liga Video Coordinator or Asst. VC', 'Community Relations', 'Soccer Coaching',
                'Event Planning', 'Soccer Scouting', 'Digital Video Editing',
            ],
        },
    },
};
